import PublicProcedureExecution from '@/classes/procedure_executions/PublicProcedureExecution'

export default class PublicProcedureExecutions extends Array {
  constructor (procedure_executions, ...rest) {
    Array.isArray(procedure_executions) ? super(...procedure_executions.map(procedure_execution => new PublicProcedureExecution(procedure_execution))) : super(...rest)
  }
}